export const EARLY_ACCESS_PAGE = 'early_access';
export const EARLY_ACCESS_PATH = '/early-access';
export const EARLY_ACCESS_SIGNUP_EVENT = 'early_access_signup';
export const NEWSLETTER_OPT_IN_EVENT = 'newsletter_opt_in';
export const GENERIC_SIGNUP_ERROR = 'Something went wrong. Please try again.';
export const INVALID_EMAIL_ERROR = 'Enter a valid email.';

const ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'referrer',
  'sourcePath',
];

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

export function isValidEmail(value) {
  const email = normalizeEmail(value);
  if (!email || email.length > 254) return false;
  if (email.includes('..') || email.startsWith('.') || email.endsWith('.')) return false;
  return EMAIL_PATTERN.test(email);
}

export function sanitizeAttribution(input = {}) {
  const attribution = {};
  for (const key of ATTRIBUTION_KEYS) {
    const raw = input[key];
    if (typeof raw !== 'string') continue;
    const value = raw.trim();
    if (!value) continue;
    attribution[key] = value.slice(0, 500);
  }
  return attribution;
}

export function collectClientAttribution({ search, referrer, pathname } = {}) {
  const attribution = sanitizeAttribution({
    sourcePath: pathname || EARLY_ACCESS_PATH,
    referrer,
  });
  const query = String(search || '');
  const params = new URLSearchParams(query.startsWith('?') ? query.slice(1) : query);
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']) {
    const value = params.get(key);
    if (value != null && String(value).trim() !== '') {
      attribution[key] = String(value).trim().slice(0, 500);
    }
  }
  return attribution;
}

export function shouldRecordMarketingConsent({ alreadyHasConsent, requestedConsent }) {
  return Boolean(requestedConsent) && !alreadyHasConsent;
}

export function buildSignupAnalyticsPayload({
  marketingConsent = false,
  attribution = {},
} = {}) {
  const payload = {
    page: EARLY_ACCESS_PAGE,
  };
  const cleanAttribution = sanitizeAttribution(attribution);
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'referrer']) {
    if (cleanAttribution[key]) payload[key] = cleanAttribution[key];
  }
  payload.marketing_opt_in = marketingConsent ? 1 : 0;
  return payload;
}

export function analyticsPayloadContainsEmail(payload, email) {
  if (!payload || typeof payload !== 'object') return false;
  const needle = normalizeEmail(email);
  if (!needle) return false;
  return Object.values(payload).some(
    (value) => typeof value === 'string' && value.toLowerCase().includes(needle)
  );
}

export function publicErrorMessage(status) {
  if (status === 400) return INVALID_EMAIL_ERROR;
  return GENERIC_SIGNUP_ERROR;
}
